import script from "./details.vue?vue&type=script&setup=true&lang=js"
export * from "./details.vue?vue&type=script&setup=true&lang=js"

import "./details.vue?vue&type=style&index=0&id=1f5c46b4&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f5c46b4"]])

export default __exports__